import { useNavigate } from 'react-router-dom';
import { getPostPath, getPostPathById } from '../types/post';
import type { Post } from '../types/post';

// Custom hook for post navigation that prioritizes hash codes
export const usePostNavigation = () => {
  const navigate = useNavigate();

  // Navigate to post using Post object
  const navigateToPost = (post: Post) => {
    const path = getPostPath(post);
    navigate(path);
  };

  // Navigate to post using ID and REQUIRED hash code
  const navigateToPostById = (postId: string, hashCode: string) => {
    if (!hashCode) {
      console.error(`Cannot navigate to post ${postId}: hash code is required`);
      return;
    }
    const path = getPostPathById(postId, hashCode);
    navigate(path);
  };

  // Check if current path is a post page (either hash or ID based)
  const isPostPage = (pathname: string = window.location.pathname): boolean => {
    return pathname.includes('/post/') || pathname.includes('/p/');
  };

  // Extract post identifier from current URL
  const getCurrentPostIdentifier = (pathname: string = window.location.pathname): string | null => {
    const postMatch = pathname.match(/\/post\/(.+)/);
    const hashMatch = pathname.match(/\/p\/(.+)/);
    
    if (hashMatch) return hashMatch[1];
    if (postMatch) return postMatch[1];
    
    return null;
  };

  return {
    navigateToPost,
    navigateToPostById,
    isPostPage,
    getCurrentPostIdentifier,
  };
};